import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message, totalPage, currentPage, total, cart,
  } = state.market;
  return {
    isLoading,
    data,
    error,
    message,
    totalPage,
    currentPage,
    total,
    cart,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
